import view from './FavoriteButton'
import enhance from './FavoriteContainer'

export default enhance(view)
